import { c as _c } from "react/compiler-runtime";
import request from '@onefootprint/request';
import { useMutation } from '@tanstack/react-query';
type SendResultSdkArgsRequest = {
  authToken: string;
  deviceResponse: string;
};
type SendResultSdkArgsResponse = {
  token: string;
  expiresAt: string;
};
const sendResultSdkArgs = async (payload: SendResultSdkArgsRequest) => {
  const {
    data: response
  } = await request<SendResultSdkArgsResponse>({
    method: 'POST',
    url: '/org/sdk_args',
    data: {
      kind: 'verify_result_v1',
      data: payload
    }
  });
  return response?.token;
};
const useSendResultSdkArgs = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: sendResultSdkArgs
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export default useSendResultSdkArgs;